import { PrimaryBigButton } from 'components/ReusableComponents/Button/BigButtons'
import DragAndDropUploader from 'components/ReusableComponents/DragAndDropUploader'
import InfoIcon from 'components/ReusableComponents/Icons/Info'
import React from 'react'
import { useSelector } from 'react-redux'
import { useToasts } from 'react-toast-notifications'
import contractApi from 'services/api/contracts'

import styles from './NonCanadaForm.module.scss'
import w9form from './w9.jpg'

/**
 *
 * @returns {React.JSX.Element}
 */
const NonCanadaForm = ({ onStepComplete }) => {
  const { addToast } = useToasts()

  const filePondRef = React.useRef(null)

  const merchantId = useSelector(s => s.hotelDetails.groupId)

  const [filePath, setFilePath] = React.useState()

  const [isSubmitLoading, setIsSubmitLoading] = React.useState(true)

  function handleUploadComplete(res) {
    const filePath = JSON.parse(res).result.path
    setFilePath(filePath)
    setIsSubmitLoading(false)
  }

  function handleSubmit() {
    contractApi.lagelInfo
      .addFile(filePath)
      .then(() => {
        addToast('w9 form added successfully', {
          appearance: 'success',
          autoDismiss: true
        })
        onStepComplete()
      })
      .catch(() => {
        addToast('Something went wrong', {
          appearance: 'error',
          autoDismiss: true
        })
        setIsSubmitLoading(true)
      })
  }

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <div className={styles.titleRow}>
          <InfoIcon className={styles.icon} />
          <p className={styles.title}>What is a W-9 form</p>
        </div>

        <p className={styles.subtitle}>
          A W-9 form is an IRS tax form that is used to confirm a person's name, address,
          and taxpayer identification number (TIN) for employment or other
          income-generating purposes.
        </p>

        <img src={w9form} alt="w9 form" className={styles.image} />
      </div>
      <div className={styles.right}>
        <p className={styles.title}>W-9 form</p>
        <p className={styles.subtitle}>Upload a pdf file or photo of your W9 form</p>

        <div className="add-guest-data__container">
          <div className="add-guest-data__uploader">
            <DragAndDropUploader
              labelIdle="
              <p class='filepond-p-mini'>drop files here</p>
              <span class='filepond-or'>or</span> <span class='filepond--label-action-mini primary'>Select file</span>"
              url="/merchantcontracts/files"
              ref={filePondRef}
              acceptedFileTypes={['application/pdf', 'image/png', 'image/jpeg']}
              onData={formData => {
                formData.append('merchantId', merchantId)
                return formData
              }}
              onLoad={handleUploadComplete}
              onError={() =>
                addToast('Something went wrong while uploading file', {
                  appearance: 'error',
                  autoDismiss: true
                })
              }
            />
          </div>
        </div>
      </div>

      <div className={styles.bottomBar}>
        <div className={styles.bottomBarContainer}>
          <div className={styles.bottomBarButtonsHolder}>
            <PrimaryBigButton disabled={isSubmitLoading} onClick={handleSubmit}>
              Complete Setup
            </PrimaryBigButton>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NonCanadaForm
